import * as angular from "angular";
import {NavigatingAwayModalComponent} from "./navigating-away-modal/navigating-away-modal.component";
import {NavigationComponent} from "./navigation.component";

export const NavigationModule = angular
    .module("app.shared.navigation", [
        "ui.bootstrap"
    ])

    .component("navigation", NavigationComponent)
    .component("navigatingAwayModal", NavigatingAwayModalComponent)

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/navigation/navigation.module.ts